import React, { useState } from 'react'
import { MANAGED_GROUP_DELETE_NOTE } from '../../../../../shared/scim/managed-groups'
import { ConfirmDialog } from '../../../../../shared/sso-workspace/confirm-dialog'

// Deleting a group, the same from its row in the list and from its own page.
// The Delete and Purge pages went in f12410b3 in favour of the list's own
// delete (a group goes to the recycle bin at once); the group page's menu
// item kept pointing at the removed route and drew a blank page (audit F6).
//
// A group the identity provider manages is deleted only after the admin
// reads what its next sync does (it makes the group again).
//
// managed(id): the managing connection's name, or null (useManagedGroups).
// remove(id): the delete itself; a rejection is the caller's to show.
export const useGroupDelete = ({ managed, remove }) => {
  const [deleting, setDeleting] = useState(null)

  const request = id => {
    if (managed(id) !== null) {
      setDeleting(id)
      return undefined
    }
    return remove(id)
  }

  const confirm = () => {
    const id = deleting
    setDeleting(null)
    return remove(id)
  }

  const dialog = (
    <ConfirmDialog
      open={deleting !== null}
      title="Delete a group your identity provider manages?"
      body={MANAGED_GROUP_DELETE_NOTE}
      confirmText="Delete group"
      onConfirm={confirm}
      onCancel={() => setDeleting(null)} />
  )

  return { request, dialog }
}
